import { Collapse, Form } from 'antd';
import { Icon } from '../../../../components/icon/icon';
import './ResizeMenuDesign.scss';
import InputComponent from '../../../../components/common/InputComponent/InputComponent';
import { CSSTransition } from 'react-transition-group';
import RightMenuDesign from '../../../../components/house/RightMenuDesign/RightMenuDesign';
import { Divider } from 'antd';
import ButtonSecondarySmall from '../../../../components/common/ButtonSecondary/ButtonSecondarySmall';
import SelectComponent from '../../../../components/common/SelectComponent/SelectComponent';
import ButtonIconGhostSmall from '../../../../components/common/ButtonIconGhost/ButtonIconGhostSmall.jsx';
import Slider from '../../../../components/common/Slider/Slider';
import ButtonIconOutlineMedium from '../../../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import {
  memo,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { DesignerPageContext } from '../../DesignerPage';
import * as THREE from 'three';
import { roundTo } from '../../../../utils/geometry/epsilon.js';
import { message } from 'antd';
import Tooltip from '../../../../components/common/Tooltip/Tooltip';
import ButtonSwitch from '../../../../components/common/ButtonSwitch/ButtonSwitch';
import { Popover } from 'antd';
import ButtonPrimaryMedium from '../../../../components/common/ButtonPrimary/ButtonPrimaryMedium';
import {
  evaluateExpression,
  getInputType,
  isValidExpression,
} from '../../../../utils/string/inputExpression.js';
import { GeometryUtils } from '../../../../utils/geometry/GeometryUtils';
import { InsideType, ModuleType } from '../../../../constants/enum.js';
import openModalFitHeight from '../../../../components/common/Modal/openModalConfirmFitHeight.jsx';

const { Panel } = Collapse;

const ResizeMenuDesign = memo(({ open, onClose }) => {
  const {
    sceneManager,
    mdSelectedModelData,
    setMdSelectedModelData,
    selectedModel,
    insideLoaderRef,
    setTick,
  } = useContext(DesignerPageContext);
  const [form] = Form.useForm();
  const [allowFit, setAllowFit] = useState(false);
  const [formLayout, setFormLayout] = useState([]);
  const [activeEditWidth, setActiveEditWidth] = useState(false);

  const scaleJob = useRef(null);

  const scaleTimerRef = useRef(null);

  const validatorSize = ({ value, min, max }) => {
    const type = getInputType(value);
    if (type === 'text') {
      return Promise.reject(new Error('Kích thước không hợp lệ'));
    }
    if (['number', 'invalid'].includes(type)) {
      const num = (parseFloat(value) || 0) / 1000;
      if (min && max) {
        if (num > max || num < min) {
          return Promise.reject(
            new Error(`${min * 1000}mm đến ${max * 1000}mm`)
          );
        }
      } else {
        if (num <= 0) {
          return Promise.reject('Kích thước không hợp lệ');
        }
      }
    }
    if (type === 'expression') {
      const num = evaluateExpression(value) / 1000;
      if (min && max) {
        if (num > max || num < min) {
          return Promise.reject(
            new Error(`${min * 1000}mm đến ${max * 1000}mm`)
          );
        }
      } else {
        if (num <= 0) {
          return Promise.reject('Kích thước không hợp lệ');
        }
      }
    }
    return Promise.resolve();
  };

  const formForCurrentCabinet = {
    frame: {
      key: 'frame',
      label: <span className="text-title-medium">Khung tủ</span>,
      children: (
        <div className="flex flex-col gap-16 items-end self-stretch">
          {mdSelectedModelData.moduleType?.includes('corner') ? (
            <>
              <div className="flex flex-col gap-6 self-stretch items-start">
                <Form.Item
                  label={
                    <div className="flex items-center justify-between self-stretch">
                      <span className="label-text-name flex gap-4 items-center">
                        Chiều dài
                        <span className="support-text-medium">
                          (Khối trái từ{' '}
                          {(mdSelectedModelData?.mdOptions?.limitRongK1?.min ??
                            0) * 1000}{' '}
                          -{' '}
                          {(mdSelectedModelData?.mdOptions?.limitRongK1?.max ??
                            0) * 1000}{' '}
                          mm)
                        </span>
                      </span>
                    </div>
                  }
                  labelCol={{ className: 'label-col-full' }}
                  tooltip={{
                    title: 'Không thể áp dụng tất cả',
                    className: 'w-16 h-16 flex absolute right-0',
                    getTooltipContainer: node => document.body,
                    icon: (
                      <span className="w-16 h-16 flex items-center">
                        <Icon.ICDeselect />
                      </span>
                    ),
                  }}
                  className="self-stretch"
                  rules={[
                    {
                      validator: (_, value) => {
                        const { max, min } =
                          mdSelectedModelData.mdOptions?.limitRongK1;
                        return validatorSize({ value, min, max });
                      },
                    },
                  ]}
                  name={'rongK1'}
                >
                  <InputComponent
                    addonBefore={
                      <span className="text-body-medium">Khối trái</span>
                    }
                    addonAfter={<span className="text-body-medium">mm</span>}
                    placeholder={'Nhập'}
                  />
                </Form.Item>
                <Form.Item
                  label={
                    <span className="support-text-medium">
                      (Khối phải từ{' '}
                      {(mdSelectedModelData?.mdOptions?.limitRongK2?.min ?? 0) *
                        1000}{' '}
                      -{' '}
                      {(mdSelectedModelData?.mdOptions?.limitRongK2?.max ?? 0) *
                        1000}{' '}
                      mm)
                    </span>
                  }
                  className="self-stretch"
                  rules={[
                    {
                      validator: (_, value) => {
                        const { max, min } =
                          mdSelectedModelData.mdOptions?.limitRongK2;
                        return validatorSize({ value, min, max });
                      },
                    },
                  ]}
                  name={'rongK2'}
                >
                  <InputComponent
                    addonBefore={
                      <span className="text-body-medium">Khối phải</span>
                    }
                    addonAfter={<span className="text-body-medium">mm</span>}
                    placeholder={'Nhập'}
                  />
                </Form.Item>
              </div>
            </>
          ) : (
            <>
              <Form.Item
                label={
                  <span className="label-text-name flex gap-4 items-center">
                    Chiều dài
                    <span className="support-text-medium">
                      (Từ{' '}
                      {(mdSelectedModelData?.mdLimitedDimensions?.width?.min ??
                        0) * 1000}{' '}
                      -{' '}
                      {(mdSelectedModelData?.mdLimitedDimensions?.width?.max ??
                        0) * 1000}{' '}
                      mm)
                    </span>
                  </span>
                }
                labelCol={{ className: 'label-col-full' }}
                tooltip={{
                  title: 'Không thể áp dụng tất cả',
                  className: 'w-16 h-16 flex absolute right-0',
                  getTooltipContainer: node => document.body,
                  icon: (
                    <span className="w-16 h-16 flex items-center">
                      <Icon.ICDeselect />
                    </span>
                  ),
                }}
                className="self-stretch"
                name="width"
                rules={[
                  {
                    validator: (_, value) => {
                      const { max, min } =
                        mdSelectedModelData?.mdLimitedDimensions?.width ?? {};
                      return validatorSize({ value, min, max });
                    },
                  },
                ]}
              >
                <InputComponent
                  addonAfter={<span className="text-body-medium">mm</span>}
                  disabled={activeEditWidth}
                  placeholder="Nhập"
                />
              </Form.Item>
            </>
          )}
          <Form.Item
            label={
              <span className="label-text-name flex gap-4 items-center">
                Chiều sâu
                <span className="support-text-medium">
                  (Từ{' '}
                  {(mdSelectedModelData.mdLimitedDimensions?.depth?.min ?? 0) *
                    1000}{' '}
                  -{' '}
                  {(mdSelectedModelData.mdLimitedDimensions?.depth?.max ?? 0) *
                    1000}{' '}
                  mm)
                </span>
              </span>
            }
            className="self-stretch"
            name={'depth'}
            rules={[
              {
                validator: (_, value) => {
                  const { max, min } =
                    mdSelectedModelData.mdLimitedDimensions?.depth;
                  return validatorSize({
                    value,
                    min,
                    max,
                  });
                },
              },
            ]}
          >
            <InputComponent
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={'Nhập'}
            />
          </Form.Item>
          <div className="flex items-end gap-8 self-stretch">
            <Form.Item
              label={
                <span className="label-text-name flex gap-4 items-center grow">
                  Chiều cao
                  <span className="support-text-medium">
                    (Từ{' '}
                    {(mdSelectedModelData.mdLimitedDimensions?.height?.min ??
                      0) * 1000}{' '}
                    -{' '}
                    {(mdSelectedModelData.mdLimitedDimensions?.height?.max ??
                      0) * 1000}{' '}
                    mm)
                  </span>
                </span>
              }
              className="self-stretch grow"
              name={'height'}
              rules={[
                {
                  validator: (_, value) => {
                    const { max, min } =
                      mdSelectedModelData.mdLimitedDimensions?.height;
                    return validatorSize({
                      value,
                      min,
                      max,
                    });
                  },
                },
              ]}
            >
              <InputComponent
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={'Nhập'}
                size={'default'}
              />
            </Form.Item>
            {['upper', 'ceiling'].some(item =>
              mdSelectedModelData.moduleType?.includes(item)
            ) && (
              <Form.Item name={'fitCeiling'}>
                <Tooltip title={'Tùy chỉnh chiều cao đụng trần'}>
                  <ButtonIconOutlineMedium
                    type="button"
                    className={allowFit ? 'active' : ''}
                    icon={<Icon.ICHeight />}
                    onClick={() => {
                      setAllowFit(prev => {
                        handleFitCeiling(!prev);
                        return !prev;
                      });
                    }}
                  />
                </Tooltip>
              </Form.Item>
            )}
          </div>
          {mdSelectedModelData.moduleType !== 'totl_lower' &&
          mdSelectedModelData.moduleType !== 'kitchen_lower_dwash' ? (
            <Form.Item
              className="flex items-center gap-8 self-stretch"
              style={{ marginTop: '-10px' }}
            >
              <div className="flex items-center gap-8 self-stretch">
                <Divider
                  type="vertical"
                  style={{ margin: 0, height: '24px' }}
                />
                <ButtonSecondarySmall
                  posIcon={<Icon.ICSelectAll />}
                  title={'Áp dụng tất cả'}
                  type={'button'}
                  onClick={async () => {
                    await form
                      .validateFields(['height', 'depth'])
                      .then(values => {
                        if (
                          getInputType(values.height) === 'number' &&
                          getInputType(values.depth) === 'number'
                        ) {
                          const height = values.height / 1000;
                          const depth = values.depth / 1000;
                          if (allowFit) {
                            applyToAllCabinets({ depth }, undefined, allowFit);
                          } else applyToAllCabinets({ height, depth });
                        }
                      })
                      .catch(_ => {});
                  }}
                />
              </div>
            </Form.Item>
          ) : (
            <Popover
              getTooltipContainer={() => document.body}
              placement="leftTop"
              trigger={['click']}
              classNames={{
                body: '!p-0 rounded-[4px]',
              }}
              styles={{
                body: { maxWidth: '302px', minWidth: '302px' },
              }}
              content={
                <div className="flex flex-col gap-0 self-stretch items-start justify-start">
                  <span
                    className="text-title-medium pt-16 px-12 pb-12"
                    style={{ fontWeight: 700 }}
                  >
                    Nhập kích thước thiết bị
                  </span>
                  <div className="flex-col flex p-12 gap-12 self-stretch">
                    <Form.Item
                      label={
                        <span className="label-text-name flex gap-4 items-center">
                          Chiều dài
                        </span>
                      }
                      name={'equipmentWidth'}
                      rules={[
                        {
                          validator: (_, value) => {
                            return validatorSize({
                              value,
                            });
                          },
                        },
                      ]}
                    >
                      <InputComponent
                        addonAfter={
                          <span className="text-body-medium">mm</span>
                        }
                        placeholder={'Nhập'}
                      />
                    </Form.Item>
                    <Form.Item
                      label={
                        <span className="label-text-name flex gap-4 items-center">
                          Chiều sâu
                        </span>
                      }
                      name={'equipmentDepth'}
                      rules={[
                        {
                          validator: (_, value) => {
                            return validatorSize({
                              value,
                            });
                          },
                        },
                      ]}
                    >
                      <InputComponent
                        addonAfter={
                          <span className="text-body-medium">mm</span>
                        }
                        placeholder={'Nhập'}
                      />
                    </Form.Item>
                    <Form.Item
                      label={
                        <span className="label-text-name flex gap-4 items-center">
                          Chiều cao
                        </span>
                      }
                      x
                      name={'equipmentHeight'}
                      rules={[
                        {
                          validator: (_, value) => {
                            return validatorSize({
                              value,
                            });
                          },
                        },
                      ]}
                    >
                      <InputComponent
                        addonAfter={
                          <span className="text-body-medium">mm</span>
                        }
                        placeholder={'Nhập'}
                      />
                    </Form.Item>
                  </div>
                  <Divider type="horizontal" className="!p-0 m-0" />
                  <div className="flex pt-8 px-12 pb-12 self-stretch items-end justify-end">
                    <ButtonPrimaryMedium
                      title={'Xác nhận'}
                      type={'button'}
                      onClick={() => {
                        form
                          .validateFields([
                            'equipmentWidth',
                            'equipmentHeight',
                            'equipmentDepth',
                          ])
                          .then(async values => {
                            if (
                              mdSelectedModelData.moduleType ===
                              'kitchen_lower_dwash'
                            ) {
                              const width =
                                (parseFloat(values['equipmentWidth']) + 54) /
                                1000;
                              const module =
                                sceneManager.cabinetManager.getModuleByGltfUuid(
                                  selectedModel?.uuid
                                );
                              insideLoaderRef.current?.scaleWashAndFridge?.(
                                parseFloat(values['equipmentWidth']) / 1000,
                                parseFloat(values['equipmentHeight']) / 1000,
                                parseFloat(values['equipmentDepth']) / 1000,
                                module
                              );
                              const currentDimensions =
                                module.formularController.currentDimensions;
                              const newHeight = currentDimensions.height;
                              const newDepth = currentDimensions.depth;
                              await handleScaleModule({
                                width,
                                newHeight,
                                newDepth,
                              });

                              setTimeout(() => {
                                sceneManager.calculateTotalCost?.({});
                              }, 0);
                            }
                            if (
                              mdSelectedModelData.moduleType === 'totl_lower'
                            ) {
                              const width =
                                (parseFloat(values['equipmentWidth']) + 134) /
                                1000;
                              const height =
                                (parseFloat(values['equipmentHeight']) + 67) /
                                1000;
                              const module =
                                sceneManager.cabinetManager.getModuleByGltfUuid(
                                  selectedModel?.uuid
                                );

                              const currentDimensions =
                                module.formularController.currentDimensions;
                              const newDepth = currentDimensions.depth;

                              insideLoaderRef.current?.scaleWashAndFridge?.(
                                parseFloat(values['equipmentWidth']) / 1000,
                                parseFloat(values['equipmentHeight']) / 1000,
                                parseFloat(values['equipmentDepth']) / 1000,
                                module
                              );
                              await handleScaleModule({
                                width,
                                height,
                                newDepth,
                              });

                              setTimeout(() => {
                                sceneManager.calculateTotalCost?.({});
                              }, 100);
                            }
                          })
                          .catch(_ => {});
                      }}
                    />
                  </div>
                </div>
              }
            >
              <ButtonSecondarySmall
                posIcon={<Icon.ICFridge />}
                title={'Kích thước theo thiết bị'}
                type={'button'}
              />
            </Popover>
          )}
        </div>
      ),
    },
    legs: {
      key: 'legs',
      label: <span className="text-title-medium">Chân tủ</span>,
      children: (
        <div className="flex flex-col gap-16 items-start self-stretch">
          <Form.Item
            name={'caoChan'}
            label={
              <span className="label-text-name flex gap-4 items-center">
                Chiều cao
                <span className="support-text-medium">
                  (Từ{' '}
                  {(mdSelectedModelData.mdOptions?.limitCaoChan?.min ?? 0) *
                    1000}{' '}
                  -{' '}
                  {(mdSelectedModelData.mdOptions?.limitCaoChan?.max ?? 0) *
                    1000}{' '}
                  mm)
                </span>
              </span>
            }
            className="self-stretch"
            rules={[
              {
                validator: (_, value) => {
                  const { max, min } =
                    mdSelectedModelData.mdOptions?.limitCaoChan;
                  return validatorSize({
                    value,
                    max,
                    min,
                  });
                },
              },
            ]}
          >
            <InputComponent
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={'Nhập'}
            />
          </Form.Item>

          <Form.Item
            name={'cabinetLegsHeightApplyToAll'}
            style={{ marginTop: '-10px' }}
          >
            <div className="flex items-center gap-8 self-stretch">
              <Divider type="vertical" style={{ margin: 0, height: '24px' }} />
              <ButtonSecondarySmall
                posIcon={<Icon.ICSelectAll />}
                title={'Áp dụng tất cả'}
                onClick={async () => {
                  await form
                    .validateFields(['caoChan'])
                    .then(values => {
                      const caoChan = values.caoChan / 1000;
                      applyToAllCabinets({ caoChan });
                    })
                    .catch(_ => {});
                }}
              />
            </div>
          </Form.Item>
        </div>
      ),
    },
  };

  const formForStone = {
    stone: {
      key: 'frame',
      label: <span className="text-title-medium">Tùy chỉnh</span>,
      children: (
        <div className="flex flex-col gap-16 items-end self-stretch">
          <Form.Item
            label={
              <span className="label-text-name flex gap-4 items-center">
                Chiều dài
              </span>
            }
            className="self-stretch"
            name={'width'}
            rules={
              [
                // {
                //   validator: (_, value) => {
                //     const { max, min } =
                //       mdSelectedModelData?.mdLimitedDimensions?.width;
                //     return validatorSize({ value, min, max });
                //   },
                // },
              ]
            }
          >
            <InputComponent
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={'Nhập'}
              disabled={true}
            />
          </Form.Item>

          <Form.Item
            label={
              <span className="label-text-name flex gap-4 items-center">
                Chiều sâu
              </span>
            }
            className="self-stretch"
            name={'depth'}
            rules={
              [
                // {
                //   validator: (_, value) => {
                //     const { max, min } =
                //       mdSelectedModelData.mdLimitedDimensions?.depth;
                //     return validatorSize({
                //       value,
                //       min,
                //       max,
                //     });
                //   },
                // },
              ]
            }
          >
            <InputComponent
              addonAfter={<span className="text-body-medium">mm</span>}
              placeholder={'Nhập'}
              disabled={true}
            />
          </Form.Item>
          <div className="flex items-end gap-8 self-stretch">
            <Form.Item
              label={
                <span className="label-text-name flex gap-4 items-center grow">
                  Chiều cao
                  <span className="support-text-medium">
                    (Từ 200 mm đến 700 mm)
                  </span>
                </span>
              }
              className="self-stretch grow"
              name={'height'}
              rules={[
                {
                  validator: (_, value) => {
                    return validatorSize({
                      value,
                      min: 0.2,
                      max: 0.7,
                    });
                  },
                },
              ]}
            >
              <InputComponent
                addonAfter={<span className="text-body-medium">mm</span>}
                placeholder={'Nhập'}
                disabled={mdSelectedModelData.type !== ModuleType.BACKSPLASH}
              />
            </Form.Item>
          </div>
        </div>
      ),
    },
  };

  const applyToAllCabinets = (mdDimensions, mdOptions, allowFit) => {
    sceneManager.autoFitModuleController.applyToAllCabinets({
      insideLoaderRef,
      selectedModelId: selectedModel?.uuid,
      allowFit,
      mdDimensions,
      mdOptions,
    });
  };

  const setData = useCallback(
    ({ fitCeiling, mdDimensions = {}, mdOptions = {}, module }) =>
      setMdSelectedModelData(prev => {
        const prevDims = prev.mdDimensions ?? {};
        const nextDims = { ...prevDims, ...mdDimensions };
        scaleJob.current = { module, prevDims, nextDims };
        return {
          ...prev,
          ...(fitCeiling !== undefined ? { fitCeiling } : {}),
          mdDimensions: nextDims,
          mdOptions: { ...(prev.mdOptions ?? {}), ...mdOptions },
        };
      }),
    []
  );

  const handleFitCeiling = useCallback(
    allowFit => {
      if (allowFit)
        sceneManager.autoFitModuleController.fitCeilingCabinet(
          insideLoaderRef,
          selectedModel?.uuid
        );
      else
        sceneManager.autoFitModuleController.unFitCeilingCabinet(
          insideLoaderRef,
          selectedModel?.uuid
        );
      if (
        ['upper'].some(item => mdSelectedModelData.moduleType.includes(item))
      ) {
        setTimeout(() => {
          openModalFitHeight({
            func: () => {
              sceneManager.autoFitModuleController.moveCeilingFollowHeightestUpperCabinet(
                { insideLoaderRef }
              );

              setTimeout(() => {
                setTick(t => t + 1);
              }, 0);
            },
          });
        });
      }

      const originalModule = sceneManager.cabinetManager.getModuleByGltfUuid(
        selectedModel?.uuid
      );
      if (originalModule) {
        const clonedScene = originalModule.group.clone();
        clonedScene.children = [
          clonedScene.children?.find(x => x.type === 'Group'),
        ];
        clonedScene.rotation.set(0, 0, 0);
        clonedScene.updateMatrixWorld(true);
        const box = new THREE.Box3().setFromObject(clonedScene);
        const size = new THREE.Vector3();
        box.getSize(size);
        setData({
          fitCeiling: allowFit,
          mdDimensions: { height: size.y },
          mdOptions: {},
        });
      }
    },
    [
      insideLoaderRef,
      mdSelectedModelData,
      sceneManager,
      selectedModel,
      allowFit,
    ]
  );

  const handleScaleModule = useCallback(
    async (mdDimensions, mdOptions) => {
      try {
        //Thay đổi chiểu cao vách bếp
        if (selectedModel?.userData?.type === ModuleType.BACKSPLASH) {
          await sceneManager.changeBacksplashHeight(mdDimensions.height);
          setTimeout(() => {
            openModalFitHeight({
              func: () => {
                sceneManager.autoFitModuleController.moveUpperFollowHeightestLowerCabinet(
                  { insideLoaderRef }
                );

                sceneManager.autoFitModuleController.moveCeilingFollowHeightestUpperCabinet(
                  { insideLoaderRef }
                );

                setTimeout(() => {
                  setTick(t => t + 1);
                }, 0);
              },
            });
          });

          return;
        }

        const originalModule =
          await sceneManager.autoFitModuleController.scaleModule(
            insideLoaderRef,
            selectedModel?.uuid,
            mdDimensions,
            mdOptions
          );

        if (
          ['lower'].some(item => mdSelectedModelData.moduleType?.includes(item))
        ) {
          if (mdDimensions.height) {
            setTimeout(() => {
              openModalFitHeight({
                func: () => {
                  sceneManager.autoFitModuleController.moveUpperFollowHeightestLowerCabinet(
                    { insideLoaderRef }
                  );

                  sceneManager.autoFitModuleController.moveCeilingFollowHeightestUpperCabinet(
                    { insideLoaderRef }
                  );

                  setTimeout(() => {
                    setTick(t => t + 1);
                  }, 0);
                },
              });
            });
          }
        } else if (
          ['upper'].some(item => mdSelectedModelData.moduleType?.includes(item))
        ) {
          if (mdDimensions.height) {
            setTimeout(() => {
              openModalFitHeight({
                func: () => {
                  sceneManager.autoFitModuleController.moveCeilingFollowHeightestUpperCabinet(
                    { insideLoaderRef }
                  );

                  setTimeout(() => {
                    setTick(t => t + 1);
                  }, 0);
                },
              });
            });
          }
        }

        const {
          currentDimensions: newMdDimensions,
          currentOptions: newMdOptions,
        } = originalModule.formularController;

        // 2) Cập nhật state
        setData({
          fitCeiling: allowFit,
          mdDimensions: newMdDimensions,
          mdOptions: newMdOptions,
          module: originalModule,
        });
        setTick(t => t + 1);
      } catch (error) {
        console.error('Error scaling module:', error);
      }
    },
    [
      allowFit,
      insideLoaderRef,
      mdSelectedModelData,
      sceneManager,
      selectedModel,
    ]
  );

  // Debounced scale handler
  const debouncedValidate = useCallback(
    (changedValues, delay = 500) => {
      if (scaleTimerRef.current) {
        clearTimeout(scaleTimerRef.current);
      }

      scaleTimerRef.current = setTimeout(async () => {
        const name = Object.keys(changedValues)[0];
        const value = changedValues[name];
        if (getInputType(value) === 'number')
          try {
            await form.validateFields([name]); // chỉ validate field này
            if (['width', 'height', 'depth'].includes(name)) {
              await handleScaleModule({ [name]: value / 1000 });
            } else if (['caoChan', 'rongK1', 'rongK2'].includes(name)) {
              await handleScaleModule({}, { [name]: value / 1000 });
            }
            await sceneManager?.calculateTotalCost?.({});
          } catch (e) {}
      }, delay);
    },
    [sceneManager, selectedModel, handleScaleModule]
  );

  useEffect(() => {
    if (
      [ModuleType.BACKSPLASH, ModuleType.COUNTERTOP].some(
        item => mdSelectedModelData.type === item
      )
    ) {
      setFormLayout([formForStone.stone]);
    } else {
      const formLayout = [formForCurrentCabinet.frame];
      if (mdSelectedModelData.moduleType?.includes('lower')) {
        formLayout.push(formForCurrentCabinet.legs);
      }

      setFormLayout(formLayout);
    }

    if (open) {
      const module = sceneManager.cabinetManager.getModuleByGltfUuid(
        selectedModel?.uuid
      );

      let check = false;
      module?.listInside.forEach(inside => {
        if (
          inside.type === InsideType.ACCESSORY_DISH_LOWER ||
          inside.type === InsideType.ACCESSORY_DISH_UPPER ||
          inside.type === InsideType.ACCESSORY_HOOD
        ) {
          check = true;
        }
      });
      setActiveEditWidth(check);

      const targetObject = module?.listInside?.find(
        inside =>
          inside.type === InsideType.ACCESSORY_WASHER ||
          inside.type === InsideType.ACCESSORY_FRIDGE
      );

      let sizeInside = null;

      if (targetObject) {
        sizeInside = GeometryUtils.getSizeRotation(
          module.group,
          targetObject.gltf
        );
      }

      form.setFieldsValue({
        width: roundTo(mdSelectedModelData.mdDimensions?.width * 1000, 0),
        height: roundTo(mdSelectedModelData.mdDimensions?.height * 1000, 0),
        depth: roundTo(mdSelectedModelData.mdDimensions?.depth * 1000, 0),
        caoChan: roundTo(mdSelectedModelData.mdOptions?.caoChan * 1000, 0),
        rongK1: roundTo(mdSelectedModelData.mdOptions?.rongK1 * 1000, 0),
        rongK2: roundTo(mdSelectedModelData.mdOptions?.rongK2 * 1000, 0),
        equipmentWidth: roundTo(sizeInside?.z * 1000, 0),
        equipmentHeight: roundTo(sizeInside?.y * 1000, 0),
        equipmentDepth: roundTo(sizeInside?.x * 1000, 0),
      });
    }
    setAllowFit(mdSelectedModelData.fitCeiling ?? false);
  }, [mdSelectedModelData, open, activeEditWidth]);

  return (
    <RightMenuDesign
      open={open}
      classNames={{
        content: 'flex flex-col p-8 items-start gap-8 grow self-stretch',
        root: 'top-84',
      }}
      styles={{ content: { backgroundColor: '#F7F7F7' } }}
      header={
        <>
          <span className="text-title-large">Kích thước</span>
          <span
            className="w-24 h-24 flex"
            style={{ cursor: 'pointer' }}
            onClick={onClose}
          >
            <Icon.ICClose />
          </span>
        </>
      }
      content={
        <>
          <Form
            layout="vertical"
            className="flex flex-col gap-8 grow self-stretch"
            onValuesChange={(changedValues, allValues) => {
              debouncedValidate(changedValues);
            }}
            initialValues={{
              width: roundTo(mdSelectedModelData.mdDimensions?.width * 1000, 0),
              height: roundTo(
                mdSelectedModelData.mdDimensions?.height * 1000,
                0
              ),
              depth: roundTo(mdSelectedModelData.mdDimensions?.depth * 1000, 0),
              caoChan: roundTo(
                mdSelectedModelData.mdOptions?.caoChan * 1000,
                0
              ),
            }}
            validateTrigger={['onChange']}
            form={form}
          >
            <Collapse
              expandIcon={({ isActive }) => (
                <span className="w-16 h-16 flex">
                  {isActive ? <Icon.ICExpandMore /> : <Icon.ICExpandLess />}
                </span>
              )}
              defaultActiveKey={['frame', 'legs']}
              onChange={() => {}}
              items={[
                ...formLayout.map(item => ({
                  ...item,
                  onKeyDown: e => {
                    e.stopPropagation();
                  },
                })),
              ]}
            />
          </Form>
        </>
      }
    />
  );
});

export default ResizeMenuDesign;

// glassSurface: [
//       {
//         key: "glassSurface",
//         label: <span className="text-title-medium">Thùng</span>,
//         children: (
//           <div className="flex flex-col gap-16 items-start self-stretch">
//             <Form.Item
//               label={"Chiều dài"}
//               name={"glassSurfaceWidth"}
//               validateTrigger={["onChange"]}
//               rules={[
//                 {
//                   validator: (_, value) => {
//                     const width = (parseFloat(value) || 0) / 1000;
//                     const { max, min } = rangeWidth;
//                     if (width > max || width < min)
//                       return Promise.reject(
//                         new Error(`${min * 1000}mm đến ${max * 1000}mm`)
//                       );
//                     handleScaleModule({ width });
//                     return Promise.resolve();
//                   },
//                 },
//               ]}>
//               <InputComponent
//                 addonAfter={<span className="text-body-medium">mm</span>}
//                 placeholder={"Nhập"}
//                 size={"default"}
//               />
//             </Form.Item>
//             <Form.Item
//               name={"glassSurfaceWidthApplyToAll"}
//               style={{ marginTop: "-10px" }}>
//               <div className="flex items-center gap-8 self-stretch">
//                 <Divider
//                   type="vertical"
//                   style={{ margin: 0, height: "24px" }}
//                 />
//                 <ButtonSecondarySmall
//                   posIcon={<Icon.ICSelectAll />}
//                   title={"Áp dụng tất cả"}
//                   onClick={() => {
//                     const width =
//                       form.getFieldValue("glassSurfaceWidth") / 1000;
//                     applyToAllCabinets({ width });
//                   }}
//                 />
//               </div>
//             </Form.Item>
//             <div className="flex items-end gap-8">
//               <Form.Item
//                 label={"Chiều cao"}
//                 name={"glassSurfaceHeight"}
//                 rules={[
//                   {
//                     validator: (_, value) => {
//                       const height = (parseFloat(value) || 0) / 1000;
//                       const { max, min } = rangeHeight;
//                       if (height > max || height < min)
//                         return Promise.reject(
//                           new Error(`${min * 1000}mm đến ${max * 1000}mm`)
//                         );
//                       handleScaleModule({ height });
//                       return Promise.resolve();
//                     },
//                   },
//                 ]}>
//                 <InputComponent
//                   addonAfter={<span className="text-body-medium">mm</span>}
//                   placeholder={"Nhập"}
//                   size={"default"}
//                 />
//               </Form.Item>
//               {["upper", "ceiling"].includes(
//                 mdSelectedModelData.moduleType
//               ) && (
//                 <Form.Item name={"fitCeiling"}>
//                   <ButtonIconOutlineMedium
//                     className={allowFit ? "active" : ""}
//                     icon={<Icon.ICHeight />}
//                     onClick={() => {
//                       setAllowFit((prev) => {
//                         handleFitCeiling(!prev);
//                         return !prev;
//                       });
//                     }}
//                   />
//                 </Form.Item>
//               )}
//             </div>
//             <Form.Item
//               name={"glassSurfaceHeihgtApplyToAll"}
//               className="flex items-center gap-8 self-stretch"
//               style={{ marginTop: "-10px" }}>
//               <div className="flex items-center gap-8 self-stretch">
//                 <Divider
//                   type="vertical"
//                   style={{ margin: 0, height: "24px" }}
//                 />
//                 <ButtonSecondarySmall
//                   posIcon={<Icon.ICSelectAll />}
//                   title={"Áp dụng tất cả"}
//                   onClick={() => {
//                     const height =
//                       form.getFieldValue("glassSurfaceHeight") / 1000;
//                     if (allowFit) {
//                       applyToAllCabinets();
//                     } else applyToAllCabinets({ height });
//                   }}
//                 />
//               </div>
//             </Form.Item>
//           </div>
//         ),
//       },
//     ],
//     materialReducer: [
//       {
//         key: "materialReducer",
//         label: <span className="text-title-medium">Thùng</span>,
//         children: (
//           <div className="flex flex-col gap-16 items-start self-stretch">
//             <Form.Item
//               label={"Chiều dài"}
//               name={"stoneSurfaceWidth"}
//               validateTrigger={["onChange"]}
//               rules={[
//                 {
//                   validator: (_, value) => {
//                     const width = (parseFloat(value) || 0) / 1000;
//                     const { max, min } = rangeWidth;
//                     if (width > max || width < min)
//                       return Promise.reject(
//                         new Error(`${min * 1000}mm đến ${max * 1000}mm`)
//                       );
//                     handleScaleModule({ width });
//                     return Promise.resolve();
//                   },
//                 },
//               ]}>
//               <InputComponent
//                 addonAfter={<span className="text-body-medium">mm</span>}
//                 placeholder={"Nhập"}
//                 size={"default"}
//               />
//             </Form.Item>
//             <Form.Item
//               name={"stoneSurfaceWidthApplyToAll"}
//               style={{ marginTop: "-10px" }}>
//               <div className="flex items-center gap-8 self-stretch">
//                 <Divider
//                   type="vertical"
//                   style={{ margin: 0, height: "24px" }}
//                 />
//                 <ButtonSecondarySmall
//                   posIcon={<Icon.ICSelectAll />}
//                   title={"Áp dụng tất cả"}
//                   onClick={() => {
//                     const width =
//                       form.getFieldValue("stoneSurfaceWidth") / 1000;
//                     applyToAllCabinets({ width });
//                   }}
//                 />
//               </div>
//             </Form.Item>
//             <div className="flex items-end gap-8">
//               <Form.Item
//                 label={"Chiều cao"}
//                 name={"stoneSurfaceHeight"}
//                 rules={[
//                   {
//                     validator: (_, value) => {
//                       const height = (parseFloat(value) || 0) / 1000;
//                       const { max, min } = rangeHeight;
//                       if (height > max || height < min)
//                         return Promise.reject(
//                           new Error(`${min * 1000}mm đến ${max * 1000}mm`)
//                         );
//                       handleScaleModule({ height });
//                       return Promise.resolve();
//                     },
//                   },
//                 ]}>
//                 <InputComponent
//                   addonAfter={<span className="text-body-medium">mm</span>}
//                   placeholder={"Nhập"}
//                   size={"default"}
//                 />
//               </Form.Item>
//               {["upper", "ceiling"].includes(
//                 mdSelectedModelData.moduleType
//               ) && (
//                 <Form.Item name={"fitCeiling"}>
//                   <ButtonIconOutlineMedium
//                     className={allowFit ? "active" : ""}
//                     icon={<Icon.ICHeight />}
//                     onClick={() => {
//                       setAllowFit((prev) => {
//                         handleFitCeiling(!prev);
//                         return !prev;
//                       });
//                     }}
//                   />
//                 </Form.Item>
//               )}
//             </div>
//             <Form.Item
//               name={"stoneSurfaceHeihgtApplyToAll"}
//               className="flex items-center gap-8 self-stretch"
//               style={{ marginTop: "-10px" }}>
//               <div className="flex items-center gap-8 self-stretch">
//                 <Divider
//                   type="vertical"
//                   style={{ margin: 0, height: "24px" }}
//                 />
//                 <ButtonSecondarySmall
//                   posIcon={<Icon.ICSelectAll />}
//                   title={"Áp dụng tất cả"}
//                   onClick={() => {
//                     const height =
//                       form.getFieldValue("stoneSurfaceHeight") / 1000;
//                     if (allowFit) {
//                       applyToAllCabinets();
//                     } else applyToAllCabinets({ height });
//                   }}
//                 />
//               </div>
//             </Form.Item>
//           </div>
//         ),
//       },
//     ],
